// src/modules/auth/ui/RequestCodeForm.tsx

/** @jsx createElement */
import { createElement } from "../../../utils/jsx.ts";

import { requestCode } from "../services/requestCode.ts";

export const RequestCodeForm = () => (
  <form class="login-form" onsubmit={async (event: SubmitEvent) => await requestCode({ event })}>
    <div class="form-header">
      <h1>Logowanie</h1>
      <p>Zaloguj się przy użyciu jednorazowego kodu wysyłanego na twój adres e-mail.</p>
    </div>

    <div class="form-body">
      <label>
        <p>Adres e-mail</p>
        <input type="email" name="email" required placeholder="imie.nazwisko@firma.pl" autocomplete="email" />
      </label>
      <button type="submit" class="submit-button">
        Zaloguj
      </button>
    </div>
  </form>
);
